import { useState } from "react";

import Date from "../../../../Core/Fields/Floating/Date";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Tab2Table1 from "./Tab2Table1";
import Tab2Table2 from "./Tab2Table2";
import {
	useGetUOMSearchMutation,
	useItemUOMMutation,
	useItemWarehouseCheckInListMutation,
	useItemWarehouseRequestListMutation,
} from "../../../../store/api/itemapi";
import { usePostWarehouseSearchMutation } from "../../../../store/api/warehousemaster";
const Tab2 = ({
	Shelf_Life_In_Days,
	End_of_Life,
	DefaultMaterialRequestType,
	ValuationMethod,
	Brand,
	WarrantyPeriod,
	WeightPerUnit,
	WeightUOM,
	AllowNegativeStock,
	setselected_barcodes_item_data,
	setselected_auto_re_order_item_data,
	setRows2,
	rows2,
	setRows3,
	rows3,
}) => {
	const [ItemWarehouseCheckInApi] = useItemWarehouseCheckInListMutation();
	const [ItemWarehouseRequestApi] = useItemWarehouseRequestListMutation();
	const [WarehouseSearchCheckAPI] = usePostWarehouseSearchMutation()
		// const [ItemUOMApi] = useItemUOMMutation();
	  const [UOMSearchInput] = useGetUOMSearchMutation();
	// Static barcode types like an API would return
	const getStaticBarcodeTypes = async () => {
		return [
			{ name: "EAN" },
			{ name: "UPC-A" },
			{ name: "CODE-39" },
			{ name: "EAN-12" },
			{ name: "EAN-8" },
			{ name: "GS1" },
			{ name: "GTIN" },
			{ name: "ISBN" },
			{ name: "ISBN-10" },
			{ name: "ISBN-13" },
			{ name: "ISSN" },
			{ name: "JAN" },
			{ name: "PZN" },
			{ name: "UPC" },
		];
	};

	const getStaticMaterialTypes = async () => {
		return [
			{ name: "Purchase" },
			{ name: "Transfer" },
			{ name: "Material Issue" },
			{ name: "Manufacture" },
		];
	};

	return (
		<>
			<div
				className="row mb-3"
				style={{ border: "1px solid #00000059", borderRadius: "5px" }}
			>
				<div className="col-12">
					<p className="boxLabel m-0">Inventory Settings</p>
				</div>
				<div className="col-3 ">
					<div className="mb-3">
						<Input
							id="Shelf_Life_In_Days"
							label="Shelf Life In Days"
							style={{ height: "30px" }}
							value={Shelf_Life_In_Days.Shelf_Life_In_Days}
							onChange={(e) =>
								Shelf_Life_In_Days.setShelf_Life_In_Days(e.target.value)
							}
						/>
					</div>
				</div>
				<div className="col-3 ">
					<div className="mb-3">
						<Date
							style={{
								height: "30px",
								border: End_of_Life?.Error ? "1px solid red" : "",
							}}
							id="End_of_Life"
							label="End of Life"
							value={End_of_Life.End_of_Life}
							onChange={(e) => End_of_Life.setEnd_of_Life(e.target.value)}
						/>
					</div>
				</div>

				<div className="col-3 ">
					<div className="mb-3">
						<SelectSearch
							list={[
								{ name: "Purchase" },
								{ name: "Transfer" },
								{ name: "Material Issue" },
								{ name: "Manufacture" },
							]}
							style={{
								height: "30px",
								border: DefaultMaterialRequestType?.Error
									? "1px solid red"
									: "",
							}}
							label="Default Material Request Type"
							getOptionLabel={(item) => item.name}
							getOptionValue={(item) => item.name}
							value={
								DefaultMaterialRequestType?.DefaultMaterialRequestType || ""
							}
							onChange={(value) =>
								DefaultMaterialRequestType?.setDefaultMaterialRequestType?.(
									value
								)
							}
						/>
					</div>
				</div>

				<div className="col-3 ">
					<div className="mb-3">
						<SelectSearch
							list={[
								{ name: "FIFO" },
								{ name: "Moving Average" },
								{ name: "LIFO" },
							]}
							style={{
								height: "30px",
								border: ValuationMethod?.Error ? "1px solid red" : "",
							}}
							label="Valuation Method"
							getOptionLabel={(item) => item.name}
							getOptionValue={(item) => item.name}
							value={ValuationMethod?.ValuationMethod || ""}
							onChange={(value) => ValuationMethod?.setValuationMethod?.(value)}
						/>
					</div>
				</div>

				<div className="col-4 ">
					<div className="mb-3">
						<Input
							style={{
								height: "30px",
								border: WarrantyPeriod?.Error ? "1px solid red" : "",
							}}
							id="WarrantyPeriod"
							label="Warranty Period (in days)"
							value={WarrantyPeriod.WarrantyPeriod}
							onChange={(e) => WarrantyPeriod.setWarrantyPeriod(e.target.value)}
						/>
					</div>
				</div>

				<div className="col-4 ">
					<div className="mb-3">
						<Input
							style={{
								height: "30px",
								border: WeightPerUnit?.Error ? "1px solid red" : "",
							}}
							label="Weight Per Unit"
							value={WeightPerUnit.WeightPerUnit}
							onChange={(e) =>
								WeightPerUnit?.setWeightPerUnit?.(e.target.value)
							}
						/>
					</div>
				</div>
				<div className="col-4 ">
					<div className="mb-3">
						<SelectSearch
							list={WeightUOM.WeightUOM_list}
							style={{
								height: "30px",
								border: WeightUOM.Error ? "1px solid red" : "",
							}}
							label="Weight UOM"
							getOptionLabel={(item) =>
								item.isNew ? "+ Create New UOM" : item.name
							}
							getOptionValue={(item) => item.name}
							createNewUrl="/master/uom/create-uom"
							createNewLabel="Create New UOM"
							value={WeightUOM.select_WeightUOM}
							onChange={(val) => WeightUOM.setselect_WeightUOM(val)}
						/>
					</div>
				</div>

				<div className="col-4 ">
					<div className="mb-3">
						<Checkbox
							id="AllowNegativeStock"
							label="Allow Negative Stock"
							value={AllowNegativeStock?.AllowNegativeStock || false}
							onChange={(val) =>
								AllowNegativeStock?.setAllowNegativeStock?.(val)
							}
						/>
					</div>
				</div>
			</div>

			<div
				className="row mb-3"
				style={{ border: "1px solid #00000059", borderRadius: "5px" }}
			>
				<div className="col-12">
					<p className="boxLabel m-0">Barcodes</p>
				</div>

				<Tab2Table1
					setselected_barcodes_item_data={setselected_barcodes_item_data}
					list_uom_data={UOMSearchInput}
					list_barcode_type_data={getStaticBarcodeTypes}
					rows2={rows2}
					setRows2={setRows2}
				/>
			</div>
			<div
				className="row mb-3"
				style={{ border: "1px solid #00000059", borderRadius: "5px" }}
			>
				<div className="col-12">
					<p className="boxLabel m-0">Auto re-order</p>
				</div>

				<Tab2Table2
					setselected_auto_re_order_item_data={
						setselected_auto_re_order_item_data
					}
					list_warehouse_check_in_data={ItemWarehouseCheckInApi}
					list_warehouse_request_data={ItemWarehouseRequestApi}
					list_material_request_type={getStaticMaterialTypes}
					search_warehouse_data = {WarehouseSearchCheckAPI}
					rows3={rows3}
					setRows3={setRows3}
				/>
			</div>
		</>
	);
};

export default Tab2;
